<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" clearable :placeholder="$t('menu.uesr')"
          v-model="formInline.title"></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-select v-model="formInline.mcSeriesModelId" filterable  :placeholder="$t('menu.VehicleModel')" clearable>
          <el-option :label="$t('menu.All')" value=" "></el-option>
          <el-option v-for="(item, index) in list" :key="index" :label="iszh == 'zh' ? item.seriesModel:item.seriesModelEn" :value="item.id" v-if="item.id != 9000"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item>
        <el-select v-model="formInline.dealerAreaId" :placeholder="$t('menu.Country')" clearable>
          <el-option :label="$t('menu.All')" value=" "></el-option>
          <el-option v-for="(item, index) in gb" :key="index" :label="iszh == 'zh' ? item.dictLabel:item.dictLabelEn" :value="item.dictValue" ></el-option>
        </el-select>
      </el-form-item> -->

    
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
        <el-button @click="reset">{{ $t('menu.Reset') }}</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px;">
      <el-button type="primary" @click="handleEdit(1,1)">{{ $t('menu.AddTo') }}</el-button>
    </div>
    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row  >
   
      <el-table-column :label="$t('menu.zcmxlsh')" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.dealerName }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('menu.zckccx')" min-width="160">
        <template slot-scope="scope">
          {{  scope.row.partName  }} 
    
        </template>
      </el-table-column>
       <el-table-column :label="$t('menu.Code')" min-width="160">
        <template slot-scope="scope">
          {{  scope.row.partCode  }} 
    
        </template>
      </el-table-column>
      <el-table-column :label="$t('menu.Currency')" min-width="180">
        <template slot-scope="scope">
         
          {{cbtyt(scope.row.accTypeIdZc)  }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('menu.xscxjg')" min-width="120">
        <template slot-scope="scope" >
          {{scope.row.purchasePrice }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('menu.lsszt')" min-width="100">
        <template slot-scope="scope">
       
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            @change="bjjgaa(scope.row)"
            :inactive-value="0">
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column :label="$t('menu.zckccz')" min-width="200">
       
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="xqdj(scope.row)">{{ $t('menu.Edit') }}</el-button>
          <el-button type="text" size="mini" @click="del(scope.row.id)">{{ $t('menu.Delete') }}</el-button>
          <!-- <el-button type="text" size="mini" @click="handleEdit(2, scope.row)">详情</el-button> -->
        </template>
      </el-table-column>
    </el-table>
  
    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, prev, pager, next"
        :total="totale">
      </el-pagination>
    </div>
    <el-dialog
        :title="$t('menu.tianjiachexing')"
        :visible.sync="dialogVisible"
        width="70%"
        :before-close="handleClose">
        <div>
             <el-form :inline="true" :model="formIn" class="demo-form-inline">

      <el-form-item >
        <el-select v-model="formIn.dealerId" filterable  :placeholder="$t('menu.zcmxlsh')" clearable>
          <el-option v-for="(item, index) in retaillist" :key="index" :label="item.dealerName" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
       <el-form-item v-if="formIn.dealerId!==''">
       <el-select v-model="formIn.mcSeriesModelId" filterable  :placeholder="$t('menu.VehicleModel')" clearable @change="xzcx">
          <el-option v-for="(item, index) in list" :key="index" :label="iszh == 'zh' ? item.seriesModel:item.seriesModelEn" :value="item.id" v-if="item.id != 9000"></el-option>
        </el-select>
      </el-form-item>
     
      </el-form>
        <el-table
    :data="modelist.filter((v) => v.partPrice!==null)"
    stripe
    ref="moli"
    style="width: 100%">
      <el-table-column
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      prop="mcSeriesModel"
      label="车型（配件分类）"
     >
       <template slot-scope="scope">
         <div  style="margin-top: 12px;" v-if="scope.row.mcSeriesModel!==undefined">{{iszh == 'zh' ? scope.row.mcSeriesModel.seriesModel:scope.row.mcSeriesModel.seriesModelEn  }}</div>
    
             </template>
    </el-table-column>
        
    <el-table-column prop="partNumber"  :label="$t('menu.cgwdpjbm')"  > </el-table-column>
    <el-table-column prop="partName"  :label="$t('menu.cgwdpjmc')"  > </el-table-column>
    <el-table-column prop="partNumber"  :label="$t('menu.Currency')"  > 
      
        <template slot-scope="scope">
       {{ currency }}
      </template>
    </el-table-column>
    <el-table-column prop="purchasePrice"  :label="$t('menu.xscxjg')"  > 
       <template slot-scope="scope">
        <el-input  :placeholder="$t('menu.xscxjg')" v-model="scope.row.purchasePrice"></el-input>
      </template>
    </el-table-column>
    
  </el-table>


         
        <!-- <div style="display: flex;font-size: 16px;align-items: flex-start;justify-content: space-between;margin-top: 10px;">
          <div>
            <div>车型（配件分类）</div>
            <div  style="margin-top: 12px;" v-if="xzmoid.mcSeriesModel!==undefined">{{iszh == 'zh' ? xzmoid.mcSeriesModel.seriesModel:xzmoid.mcSeriesModel.seriesModelEn  }}</div>
          </div>
          <div>
            <div>配件编码</div>
            <div style="margin-top: 12px;">{{ xzmoid.partNumber}}</div>
          </div>
          <div>
            <div>配件名称</div>
            <div style="margin-top: 12px;">{{iszh == 'zh' ? xzmoid.partName:xzmoid.partNameEn }}</div>
          </div>
          <div>
            <div>币种</div>
            <div style="margin-top: 12px;">{{ currency}}</div>
          </div>
          <div>
            <div>采购价格</div>
            <div>
               <el-input  placeholder="价格" v-model="xzmoid.purchasePrice"></el-input>
          </div>
          </div>
        </div> -->
        </div>

        <span slot="footer" class="dialog-footer">
          
          <el-button type="primary" @click="postup">{{$t('menu.Confirm')}}</el-button>
         </span>
      </el-dialog>
      <el-dialog
        :title="$t('menu.Edit')"
        :visible.sync="dialogVisiblea"
        width="30%"
        :before-close="handleClose">
       <div style="display: flex;align-items: center;">
        <div style="width: 150px;">{{ $t('menu.xscxjg') }} </div>
        <el-input v-model="postidfo.purchasePrice" :placeholder="$t('menu.xscxjg')"></el-input>
        
        
       </div>
        <div style="display: flex;align-items: center;margin-top: 10px;">
        <div style="width: 150px;">{{ $t('menu.zckckcxx') }} </div>
        <el-input v-model="postidfo.safetyStock" :placeholder="$t('menu.zckckcxx')"></el-input>
        
       
       </div>
        <div style="width: 100%;display: flex;justify-content: center;margin-top: 20px;">
            <el-button style="" @click="bjjg()" type="primary">{{$t('menu.Confirm')}}</el-button>
        </div>
          
      </el-dialog>
  </div>
</template>

<script>
import { partPriceOfRetailer, listMcSeriesModelsac,gbquerytype,deleOfRetailer,putOfRetailer, pageQueryPartCategory,getInfo,pageQueryPart,retailerlist,postOfRetailer,listAccType } from "../../api/api";

export default {
  data () {
    return {
      iszh:sessionStorage.getItem('i18n'),
      currency:'', //币种
      cbcnaa:'',
      list: [],
      postidfo:{},
      dialogVisible:false,
     dialogVisiblea:false,
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
      mation: [], //列表
      formInline: {
        title: "",

        mcSeriesModelId: '',
    
       
        category: "",
        claimType: '',
        type: "",
        dealerAreaId:'',
        orderType:''
      },
      formIn:{
        title:'',
        dealerId:'',
        mcSeriesModelId:'',
      },
      acclist:[],
      uesrid:'',
      gb:[],
      mcSeriesModelId:'',
      categoryName:'',
      retaillist:[],
      modelist:[],
      xzid:'',
      xzmoid:{},
    };
  },


  mounted () {
    this.listMcSeriesModel()
    this.biao();
    this.acc()
 
    this.getInfoa()
    this.retail()
  },
  methods: {
    postup(){
    console.log(this.$refs.moli.selection);
    let a =this.$refs.moli.selection
    if(a.length>0){
      a.forEach(e=>{
        this.ccbca(e)
      })
      
      
    }else{
      this.$message.error('请选择车辆');
    }
      // moli
      // let param={
      //   accTypeIdZc:sessionStorage.getItem('accTypeIdLs'),
      //   dealerId:this.formIn.dealerId,
      //   partCode:this.xzmoid.partNumber,
      //   partId:this.xzmoid.id,
      //   partName:this.xzmoid.partName,
      //   purchasePrice:this.xzmoid.purchasePrice,
      //   status:'1'
      // }
      // const { data: res } = await postOfRetailer(param)
   
    },
    async ccbca(e){
       let param={
        accTypeIdZc:this.cbcnaa,
        dealerId:this.formIn.dealerId,
        partCode:e.partNumber,
        partId:e.id,
        partName:e.partName,
        purchasePrice:e.purchasePrice,
        status:'1'
      }
      const { data: res } = await postOfRetailer(param)
      console.log(123,res);
      
      if(res.code==500){
this.$message.error(res.msg);
      }else{
          this.biao();
          this.dialogVisible=false
      }
     
    },
    xzlist(e){
      let a =this.modelist
      a.forEach(z=>{
        if(z.id==e){
          this.xzmoid=z
        }
      })
      
    },
    cbtyt(e){
      let a =this.acclist
      let b =''
      a.forEach(z=>{
        if(z.id==e){
          b=z.currencyName
        }
      })
      return b
    },
   async bjjg(){
      
       let param = this.postidfo
    
      const { data: res } = await putOfRetailer(param)
      if(res.code==200){
      this.handleClose()
      }else{
        this.$message.error(res.msg);
      }
     
    },
     async bjjgaa(e){
        console.log(e);
        
       let param = e
    
      const { data: res } = await putOfRetailer(param)
      if(res.code==200){
      this.handleClose()
      }else{
        this.$message.error(res.msg);
      }
     
    },
    async del(e){
      
       let param ={}
    
      const { data: res } = await deleOfRetailer(param,e)
      if(res.code==200){
      this.biao()
      }else{
        this.$message.error(res.msg);
      }
     
    },
    xzcx(e){
      console.log(e);
      this.mcSeriesModelId=e
        this.modelist=[]
      this.biaocc()
    },
    async biaocc () {
      let param = new URLSearchParams();
      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = '';
      const { data: res } = await pageQueryPartCategory(
        param,
        1,
        100,
        mcSeriesModelId,
        searchKey
      );

      let mation = res.data.list;
      this.categoryName=''
     
      res.data.list.forEach((z,i)=>{
        if(z.useType==3){
          if (this.iszh == 'zh') {
        this.categoryName = mation[i].categoryName;
      } else {
        this.categoryName = mation[i].categoryNameEn;
      }
      // this.categoryId = this.mation[i].id;
   


this.onsubtitle(mation[i].id, this.categoryName);
        }
      })
    },
   async onsubtitlea(){
    
      this.page = 1
     
      let param = new URLSearchParams();
      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = this.formIn.title;
      let categoryId = '';
      const { data: res } = await pageQueryPart(
        param,
        this.page,
        '1000',
        mcSeriesModelId,
        searchKey,
        categoryId
      );
      this.modelist = res.data.list
      console.log(1,this.modelist);
      
      
   },
      async onsubtitle (e, i) {
     
      
      this.page = 1
      let param = new URLSearchParams();
      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = this.formIn.title;
      let categoryId = e;
      this.modelist=[]
      console.log(1);
      
      const { data: res } = await pageQueryPart(
        param,
        this.page,
        '1000',
        mcSeriesModelId,
        searchKey,
        categoryId
      );
      this.modelist = res.data.list
      console.log(2,this.modelist);

    },
    handleClose(){
      this.dialogVisible=false
      this.dialogVisiblea=false
     this.postidfo={}
     this.biao()
    },
    xqdj(e){
      this.postidfo={...e}
    
      this.dialogVisiblea=true
    },
    //零售商
     async retail () {
      let param = new URLSearchParams();
      const { data: res } = await retailerlist(param,1,1000)
    this.retaillist  = res.rows
   

    },
    async acc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
    this.acclist  = res.data
      this.infoaa()

    },
    getInfoa () {
      getInfo().then(r => {
        if (r.data.code == 200) {
      
          this.uesrid = r.data.user.dealers[0].id
          this.gbquerytype()
        }
      })
    },
     //账户 
     async gbquerytype () {
      let param = new URLSearchParams();
      const { data: res } = await gbquerytype(param, 'sys_dealer_area/%20/', this.uesrid);
      this.gb = res.data
    },
    async infoaa () {
      let param = new URLSearchParams();
      const { data: res } = await getInfo(param)
      

      this.acclist.forEach(e => {
        if (e.id == res.user.dealers[0].accTypeIdLs) {
            this.currency=e.currencyType
          this.cbcnaa=e.id
   

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
       
      })
    },
   
   
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();

      const { data: res } = await listMcSeriesModelsac(param);

      this.list = res.data;
      // this.formInline.mcSeriesModelId = this.mcSeriesModelId/

    },
   
    async biao () {
      let param = new URLSearchParams();
      let status=''
      const { data: res } = await partPriceOfRetailer(
        param,
        this.currentPage3,
        this.pagesize,
        this.formInline.mcSeriesModelId,
        this.formInline.title,
        status,
      );
      this.mation = res.rows;
      this.totale = res.total;
    },
    //表单点击
     handleEdit (index, row) {
      this.formIn={
         title:'',
        dealerId:'',
        mcSeriesModelId:'',
      }
      this.modelist=[]
       this.dialogVisible=true
      },
 

    //搜索
    onSubmit () {
      this.biao();
    },
    reset(){
      this.formInline= {
        title: "",
        startTime: "",
        endTime: "",
        mcSeriesModelId: '',
        contact: "",
        status: '',
        category: "",
        claimType: '',
        type: "",
        orderType:'',
      },
      this.biao();
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.biao();
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.biao();
    },
 
  },
};
</script>

<style lang="less" scoped>
.blueColor{
  color: red;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 20px;
  border-bottom: 1px solid #d7d7d7;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
}
</style>